import React from 'react'
import { Link } from 'react-router-dom'
import ProductItem from './productItem'

const ProductGrid7 = ({Title,Discription,To,Products,Columns}) => {
  return (
    <div className='public_home_product_grid_1_container'>
      <div className='public_home_product_grid_1_title'>
        <div className='public_home_product_grid_1_title_details'>
            <h4>{Title}</h4>
            <p>{Discription}</p>
        </div>
        <div className='public_home_product_grid_1_title_link'>
            {To !== "" && To !== undefined &&
                <Link to={To}>see more</Link>
            }
        </div>
      </div>
      <div className='public_home_product_grid_1_products_wrapper'>
        <div className='public_home_product_grid_7_products'>
          {
              Products.slice(0, parseInt(Columns)).map((product,index)=>{
                  return(
                      <div style={{width:String((100/(parseInt(Columns)))-0.2)+"%", marginTop:'0.2%', marginRight:'0.2%'}} key={index}>
                          <ProductItem Product={product} />
                      </div>
                  )
              })
          }
        </div>
      </div>
    </div>
  )
}

export default ProductGrid7
